import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setAuthHeader } from './apiHelpers';
import { liveAppUrl, demoAppUrl, localAppUrl } from '../../config';

const currentURL = window.location.href;
const appURL = currentURL.includes('localhost') ? localAppUrl : currentURL.includes('glidix') ? demoAppUrl : liveAppUrl;

export const categoryApi = createApi({
  reducerPath: 'categoryApi',
  baseQuery: fetchBaseQuery({
    baseUrl: appURL,
    prepareHeaders: (headers) => {
      setAuthHeader(headers);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchCategories: builder.query({
      query: (params) => {
        if (params?.search) {
          return `/category/list?page=${params?.page ? params?.page : 1}&perPage=${params?.perPage ? params?.perPage : 10}&search=${params.search}`;
        } else if (params?.page) {
          return `/category/list?page=${params?.page ? params?.page : 1}&perPage=${params?.perPage ? params?.perPage : 10}`;
        } else {
          return '/category/list';
        }
      }
    }),
    fetchCategoryDetail: builder.query({
      query: (id) => `/category/detail/${id}`,
    }),
    createCategory: builder.mutation({
      query: (credentials) => ({
        url: '/category/store',
        method: 'POST',
        body: credentials,
      }),
    }),
    updateCategory: builder.mutation({
      query: (credentials) => ({
        url: '/category/update',
        method: 'PUT',
        body: credentials,
      }),
    }),
    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `/category/delete/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useFetchCategoriesQuery,
  useFetchCategoryDetailQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation
} = categoryApi;
